// FlowEmptyState — a tidy resting state for a report whose series/rows are
// empty (the contract says both can be), so a card with no data reads as
// "nothing in the window" rather than a broken chart.

import { Box } from '@mui/material';

import { tokens } from '../../../../styles/tokens';

interface FlowEmptyStateProps {
  message?: string;
  height?: number;
}

export const FlowEmptyState = ({
  message = 'No flow in window',
  height = 120,
}: FlowEmptyStateProps) => {
  return (
    <Box
      sx={{
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: tokens.text.muted,
        fontSize: 11.5,
        letterSpacing: '0.3px',
      }}
    >
      {message}
    </Box>
  );
};
